import definition from './navigation.service';

/**
 * NavigationApi settings
 * @type {{name: string, definition: NavigationApi}}
 */
export default {
    name: 'NavigationApi',
    definition
};



// WEBPACK FOOTER //
// ./app/services/api/navigation/index.js